"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ProductCrossActivationStatus = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../../../../../");

var _productsStatus = require("../productsStatus");

var _ProductCrossActivationButton = require("./ProductCrossActivationButton");

var ProductCrossActivationStatus = function ProductCrossActivationStatus(_ref) {
  var status = _ref.status,
      features = _ref.features,
      inverted = _ref.inverted,
      swicusOrgId = _ref.swicusOrgId;

  if (status === _productsStatus.PRODUCT_STATUS.CURRENT_PRODUCT) {
    return /*#__PURE__*/_react["default"].createElement(_.Icon, {
      "data-qa": "current-product-icon",
      className: "product-check",
      name: "check"
    });
  }

  var crossActivationEnabled = features && features.crossActivation;
  if (!crossActivationEnabled || !swicusOrgId) return null;
  return /*#__PURE__*/_react["default"].createElement(_ProductCrossActivationButton.ProductCrossActivationButton, {
    status: status,
    inverted: inverted
  });
};

exports.ProductCrossActivationStatus = ProductCrossActivationStatus;